export default "__VITE_ASSET__f10c2cba__"